const Data = [
    {
        name: "Devanaboyina Saketh Ram",
        position: "President",
        imageUrl: "/assets/images/members/GB26/DSakethRam.jpg",
        facebookLink: "",
        linkedinLink: "https://www.linkedin.com/in/devanaboyina-saketh-ram-818944298/",
        email: "d.ram@gyws.org",
    },
    {
        name: "Madhushree Dujari",
        position: "Vice President",
        imageUrl: "/assets/images/members/GB26/MadhushreeDujari.jpg",
        facebookLink: "",
        linkedinLink: "",
        email: ""
    },
    {
        name: "Ayush Kumar",
        position: "General Secretary",
        imageUrl: "/assets/images/members/GB26/AyushKumar.jpg",
        facebookLink: "https://www.facebook.com/share/1AF638fq7M/",
        linkedinLink: "https://www.linkedin.com/in/ayush-kumar-519a6328b/",
        email: "ayush.kumar@gyws.org"
    },
    {
        name: "Sachin Maloo",
        position: "Treasurer",
        imageUrl: "/assets/images/members/GB26/Sachin.jpeg",
        facebookLink: "https://www.facebook.com/profile.php?id=100094359082523&mibextid=ZbWKwL",
        linkedinLink: "https://www.linkedin.com/in/sachin-gautam-chand-maloo-742aa1287/",
        email: "sachin.maloo@gyws.org"
    },
    {
        name: "Khushi Srivastava",
        position: "Human Resource Manager",
        imageUrl: "/assets/images/members/GB26/KhushiSrivastava.jpg",
        facebookLink: "https://www.facebook.com/share/4tVqAjjFVomedZLm/?mibextid=qi2Omg",
        linkedinLink: "https://www.linkedin.com/in/khushi-srivastava-7b6b772a6/",
        email: "khushi.srivastava@gyws.org"
    },
    {
        name: "Puneet Gupta",
        position: "Assistant Secretary",
        imageUrl: "/assets/images/members/GB26/PuneetGupta.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100056484364626&mibextid=ZbWKwL",
        linkedinLink: "https://www.linkedin.com/in/puneet-gupta-316579297/",
        email: "puneet.gupta@gyws.org"
    },
    {
        name: "Aaratrika Bhattacharya",
        position: "School Development Officer",
        imageUrl: "/assets/images/members/GB26/AaratrikaBhattacharya.jpg",
        facebookLink: "https://www.facebook.com/share/18uKNsaEmT/",
        linkedinLink: "https://www.linkedin.com/in/aaratrika-bhattacharya-61176a280/",
        email: "aaratrika.bhattacharya@gyws.org"
    },
    {
        name: "Sharanya Baidya",
        position: "Hostel Committee Officer",
        imageUrl: "/assets/images/members/GB26/SharanyaBaidya.jpeg",
        facebookLink: "https://www.facebook.com/profile.php?id=61554570063765",
        linkedinLink: "https://www.linkedin.com/in/sharanya-baidya-994910297/",
        email: "sharanya.baidya@gyws.org"
    },
    {
        name: "Vivekadithya Yayavaram",
        position: "Chief Fundraising Officer",
        imageUrl: "/assets/images/members/GB26/VivekadithyaYayavaram.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=61551520094855",
        linkedinLink: "https://www.linkedin.com/in/vivekadithya-yayavaram-8002a2291/",
        email: "y.vivekadithya@gyws.org"
    },
    {
        name: "Krishna Ashrai Chochipatla",
        position: "Foreign and Corporate Relations Officer",
        imageUrl: "/assets/images/members/GB26/Krishna.jpg",
        facebookLink: "https://www.facebook.com/share/1AVK2AdbUd/",
        linkedinLink: "https://www.linkedin.com/in/krishna-ashrai/",
        email: "krishna.chochipatla@gyws.org"
    },
    {
        name: "Aliva Patro",
        position: "Public Relations Officer",
        imageUrl: "/assets/images/members/GB26/Aliva.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=61562000387700",
        linkedinLink: "https://www.linkedin.com/in/aliva-patro-a3a5912b3/",
        email: "aliva.patro@gyws.org"
    },
    {
        name: "Arka Ghosh",
        position: "Chief Technical Officer",
        imageUrl: "/assets/images/members/GB26/ArkaGhosh.jpg",
        facebookLink: "https://www.facebook.com/share/16fGCnvDJY/",
        linkedinLink: "https://www.linkedin.com/in/arka-ghosh-2729b529a/",
        email: "arka.ghosh@gyws.org"
    },
    {
        name: "Harsh Sahu",
        position: "Community Outreach Officer",
        imageUrl: "/assets/images/members/GB26/Harsh.jpg",
        facebookLink: "",
        linkedinLink: "",
        email: ""
    },
    {
        name: "Zalavadiya Dishil",
        position: "Chief Executive Officer, LiGHT",
        imageUrl: "/assets/images/members/GB26/Dishil.jpg",
        facebookLink: "",
        linkedinLink: "",
        email: ""
    }
]

export default Data;